/* Everyday Unboxed theme script. No dependencies. */
(() => {
  const T = window.theme || { routes: {}, strings: {} };
  const S = T.strings || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = matchMedia('(max-width: 760px)');
  const fmt = (str, vars) => String(str || '').replace(/{{\s*(\w+)\s*}}|%(\w+)%/g, (_, a, b) => { const k = a || b; return vars && vars[k] != null ? vars[k] : ''; });

  /* ---------- header height (sticky offsets) ---------- */
  const setHeaderH = () => {
    const h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  };
  addEventListener('resize', setHeaderH); setHeaderH();

  /* ---------- toast ---------- */
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('show'), 2400);
  }

  /* ---------- drawers (menu, cart, mobile filters) ---------- */
  let openDrawerEl = null, returnFocus = null;
  const scrim = () => $('[data-scrim]');
  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(x => x.offsetParent !== null || x === document.activeElement);
  }
  function openDrawer(id, opener) {
    const d = document.getElementById(id); if (!d) return;
    if (openDrawerEl && openDrawerEl !== d) closeDrawer(false);
    returnFocus = opener || document.activeElement; openDrawerEl = d;
    d.hidden = false;
    if (d.hasAttribute('data-filter-panel')) { d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true'); }
    const sc = scrim(); if (sc) sc.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => { d.classList.add('open'); if (sc) sc.classList.add('show'); });
    $$(`[data-open-drawer="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const c = $('[data-close-drawer]', d); if (c) c.focus(); }, 40);
  }
  function closeDrawer(restore = true) {
    const d = openDrawerEl; if (!d) return;
    openDrawerEl = null;
    d.classList.remove('open');
    const sc = scrim(); if (sc) sc.classList.remove('show');
    document.body.style.overflow = '';
    $$(`[data-open-drawer="${d.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => {
      if (openDrawerEl === d) return;
      if (d.hasAttribute('data-filter-panel')) { d.removeAttribute('role'); d.removeAttribute('aria-modal'); }
      else d.hidden = true;
      if (!openDrawerEl && sc) sc.hidden = true;
    }, reduce() ? 0 : 260);
    if (restore && returnFocus && document.contains(returnFocus)) returnFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      const id = opener.getAttribute('data-open-drawer');
      if (id === 'CartDrawer' && T.cartType !== 'drawer') return;
      if (!document.getElementById(id)) return;
      e.preventDefault(); openDrawer(id, opener); return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.closest('[data-scrim]')) { closeDrawer(); return; }
    if (openDrawerEl && e.target.closest('a[href]') && openDrawerEl.contains(e.target)) closeDrawer(false);
  });
  document.addEventListener('keydown', e => {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(openDrawerEl); if (!f.length) return;
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  mobile.addEventListener('change', () => { if (openDrawerEl && openDrawerEl.hasAttribute('data-filter-panel') && !mobile.matches) closeDrawer(false); });

  /* ---------- cart ---------- */
  const SECTION = 'cart-drawer';
  async function refreshCount() {
    try {
      const c = await (await fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      $$('#CartCount').forEach(el => { el.textContent = c.item_count; el.dataset.n = c.item_count; });
      const t = $('#CartToggle');
      if (t) t.setAttribute('aria-label', (c.item_count === 1 ? 'Cart, 1 item' : `Cart, ${c.item_count} items`));
      return c;
    } catch (_) { return null; }
  }
  function renderDrawer(sections) {
    if (!sections || !sections[SECTION]) return;
    const html = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    const next = $('#CartDrawerInner', html), cur = $('#CartDrawerInner');
    if (next && cur) cur.replaceWith(next);
  }
  async function addToCart(form, button) {
    const fd = new FormData(form);
    if (T.cartType === 'drawer') fd.append('sections', SECTION);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
      if (T.cartType !== 'drawer') { location.href = T.routes.cart; return; }
      renderDrawer(data.sections);
      await refreshCount();
      openDrawer('CartDrawer', button);
      toast(S.added);
    } catch (err) {
      const box = form.querySelector('[data-atc-error]');
      if (box) { box.textContent = err.message || S.error; box.hidden = false; }
      else toast(err.message || S.error);
    } finally {
      if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
    }
  }
  async function changeLine(line, quantity, focusSel) {
    const body = { line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: [SECTION] };
    const row = $(`[data-line="${line}"]`); if (row) row.classList.add('is-updating');
    try {
      const res = await fetch(T.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
      renderDrawer(data.sections);
      await refreshCount();
      if (body.quantity === 0) toast(S.removed);
      const target = (focusSel && $(focusSel)) || $('#CartDrawerInner [data-close-drawer]');
      if (target) target.focus();
    } catch (err) {
      if (row) row.classList.remove('is-updating');
      toast(err.message || S.error);
    }
  }
  document.addEventListener('submit', e => {
    const form = e.target;
    if (form.matches('.buy-form, .quick-form')) {
      if (form.matches('.buy-form') && form.dataset.blocked === 'true') { e.preventDefault(); return; }
      e.preventDefault();
      addToCart(form, e.submitter || form.querySelector('[type=submit]'));
    }
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-change]'); if (!b) return;
    e.preventDefault();
    const line = b.dataset.lineChange, dir = b.dataset.qty;
    changeLine(line, dir, dir === '0' ? null : `[data-line-change="${line}"][data-qty]${b.matches('.remove') ? '' : ':not(.remove)'}`);
  });
  document.addEventListener('change', e => {
    const i = e.target.closest('[data-line-input]'); if (i) changeLine(i.dataset.lineInput, i.value, `[data-line-input="${i.dataset.lineInput}"]`);
  });

  /* ---------- predictive search ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type=search]');
      this.box = this.querySelector('.suggest');
      this.idx = -1;
      let t;
      this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.search(), 220); });
      this.input.addEventListener('keydown', e => this.keys(e));
      this.input.addEventListener('blur', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 150));
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 150));
    }
    async search() {
      const q = this.input.value.trim();
      if (!q) { this.close(); return; }
      const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = $('#shopify-section-predictive-search', doc);
        this.box.innerHTML = inner ? inner.innerHTML : '';
        this.open();
      } catch (_) { this.close(); }
    }
    options() { return $$('[role=option]', this.box); }
    open() { this.box.hidden = false; this.input.setAttribute('aria-expanded', 'true'); this.idx = -1; }
    close() { this.box.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); this.idx = -1; }
    keys(e) {
      if (e.key === 'Escape') { this.close(); return; }
      const o = this.options(); if (this.box.hidden || !o.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.idx = (this.idx + (e.key === 'ArrowDown' ? 1 : -1) + o.length) % o.length;
        o.forEach((x, i) => x.setAttribute('aria-selected', i === this.idx));
        this.input.setAttribute('aria-activedescendant', o[this.idx].id);
        o[this.idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.idx > -1) { e.preventDefault(); location.href = o[this.idx].href; }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
  document.addEventListener('click', e => {
    const f = e.target.closest('[data-focus-search]'); if (!f) return;
    const i = document.getElementById(f.dataset.focusSearch); if (!i) return;
    e.preventDefault(); window.scrollTo({ top: 0 }); i.focus();
  });

  /* ---------- product page ---------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      this.data = json ? JSON.parse(json.textContent) : { variants: [], option_names: [] };
      this.form = this.querySelector('.buy-form');
      this.atc = this.querySelector('[data-atc]');
      this.err = this.querySelector('[data-atc-error]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.sets = [...this.querySelectorAll('fieldset[data-option-index]')];
      this.require = this.dataset.requireChoice === 'true';
      this.initGallery(); this.initQty(); this.initOptions(); this.initSticky();
    }
    /* gallery */
    initGallery() {
      const track = this.querySelector('[data-track]'); if (!track) return;
      this.track = track;
      const n = track.children.length, pos = this.querySelector('[data-pos]');
      const dots = [...this.querySelectorAll('.dots span')], thumbs = [...this.querySelectorAll('[data-thumb]')];
      const set = i => {
        if (pos) pos.textContent = `${i + 1} / ${n}`;
        dots.forEach((d, k) => d.classList.toggle('on', k === i));
        thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i));
      };
      this.goTo = i => { const c = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: c * track.clientWidth, behavior: reduce() ? 'auto' : 'smooth' }); set(c); };
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => set(Math.round(track.scrollLeft / track.clientWidth))); }, { passive: true });
      thumbs.forEach(t => t.addEventListener('click', () => this.goTo(+t.dataset.thumb)));
      track.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); this.goTo(Math.round(track.scrollLeft / track.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1));
      });
    }
    showMedia(id) {
      if (!id || !this.track) return;
      const slides = [...this.track.children], i = slides.findIndex(s => s.dataset.mediaId == id);
      if (i > -1) this.goTo(i);
    }
    /* quantity */
    initQty() {
      const q = this.querySelector('[data-qty]'); if (!q) return;
      const max = +q.max || 99;
      this.querySelectorAll('[data-qty-step]').forEach(b => b.addEventListener('click', () => { q.value = Math.max(1, Math.min(max, (+q.value || 1) + +b.dataset.qtyStep)); }));
      q.addEventListener('change', () => { q.value = Math.max(1, Math.min(max, Math.round(+q.value) || 1)); });
    }
    /* options */
    selected() { return this.sets.map(fs => { const c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    initOptions() {
      this.sets.forEach(fs => fs.addEventListener('change', () => { this.clearError(); this.update(true); }));
      if (this.form) this.form.addEventListener('submit', e => this.guard(e), true);
      this.update(false);
    }
    findVariant(sel) { return this.data.variants.find(v => v.options.every((o, i) => o === sel[i])); }
    update(fromUser) {
      const sel = this.selected();
      const complete = sel.every(v => v !== null);
      // option availability marks
      this.sets.forEach((fs, i) => {
        const label = fs.querySelector('[data-selected-label]');
        if (label && sel[i] !== null) label.textContent = sel[i];
        fs.querySelectorAll('input[data-option-value]').forEach(inp => {
          const ok = this.data.variants.some(v => v.available && v.options[i] === inp.value && v.options.every((o, k) => k === i || sel[k] === null || sel[k] === o));
          const lab = fs.querySelector(`label[for="${inp.id}"]`);
          if (lab) { lab.classList.toggle('is-na', !ok); const sr = lab.querySelector('[data-na-text]'); if (sr) sr.textContent = ok ? '' : `, ${S.unavailable.toLowerCase()}`; }
        });
      });
      const avail = this.querySelector('[data-avail]'), at = this.querySelector('[data-avail-text]');
      const priceBox = this.closest('.wrap').querySelector('[data-price]');
      const stickyBtn = this.querySelector('[data-sticky-atc]'), stickyPrice = this.querySelector('[data-sticky-price]');
      this.variant = null;
      if (!this.sets.length) { this.variant = this.data.variants[0]; }
      else if (complete) { this.variant = this.findVariant(sel) || false; }
      const v = this.variant;
      if (v === null) {
        if (avail) avail.className = 'avail wait';
        if (at) at.textContent = S.chooseToSee;
        this.setAtc(S.addToCart, false);
        if (stickyBtn) stickyBtn.textContent = S.choose;
        if (this.idInput && this.require) this.idInput.value = '';
        this.blocked = 'choose';
      } else if (v === false) {
        if (avail) avail.className = 'avail no';
        if (at) at.textContent = S.unavailable;
        this.setAtc(S.unavailable, true);
        if (stickyBtn) stickyBtn.textContent = S.unavailable;
        this.blocked = 'unavailable';
      } else {
        if (this.idInput) this.idInput.value = v.id;
        if (priceBox && v.price_html) priceBox.innerHTML = v.price_html;
        if (stickyPrice) stickyPrice.textContent = (priceBox && priceBox.querySelector('.price')) ? priceBox.querySelector('.price').textContent : stickyPrice.textContent;
        if (v.available) {
          if (avail) avail.className = 'avail ok';
          if (at) at.textContent = S.available;
          this.setAtc(S.addToCart, false);
          if (stickyBtn) stickyBtn.textContent = S.addToCart;
          this.blocked = null;
        } else {
          if (avail) avail.className = 'avail no';
          if (at) at.textContent = this.sets.length ? fmt(S.isUnavailable, { value: sel.join(' / ') }) : S.soldOut;
          this.setAtc(S.soldOut, true);
          if (stickyBtn) stickyBtn.textContent = S.soldOut;
          this.blocked = 'unavailable';
        }
        if (fromUser) {
          this.showMedia(v.media_id);
          const url = new URL(location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        }
      }
      if (this.form) this.form.dataset.blocked = this.blocked ? 'true' : 'false';
    }
    setAtc(text, disabled) {
      if (!this.atc) return;
      this.atc.textContent = text;
      if (disabled) this.atc.setAttribute('aria-disabled', 'true'); else this.atc.removeAttribute('aria-disabled');
    }
    clearError() { if (this.err) { this.err.hidden = true; this.err.textContent = ''; } }
    guard(e) {
      if (!this.blocked) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (this.blocked === 'choose') {
        const i = this.selected().findIndex(v => v === null), fs = this.sets[i];
        const name = (this.data.option_names[i] || '').toLowerCase();
        if (this.err) { this.err.textContent = fmt(S.chooseFirst, { option: name }); this.err.hidden = false; }
        if (fs) { fs.scrollIntoView({ block: 'center', behavior: reduce() ? 'auto' : 'smooth' }); const first = fs.querySelector('input'); if (first) setTimeout(() => first.focus({ preventScroll: true }), reduce() ? 0 : 300); }
      } else if (this.err) { this.err.textContent = this.atc ? this.atc.textContent : S.unavailable; this.err.hidden = false; }
    }
    /* sticky add to cart (mobile) */
    initSticky() {
      const bar = this.querySelector('[data-sticky]'), row = this.querySelector('[data-buy-row]'); if (!bar || !row) return;
      document.body.classList.add('has-sticky');
      const btn = bar.querySelector('[data-sticky-atc]');
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1;
      });
      io.observe(row);
      btn.addEventListener('click', () => {
        if (this.blocked === 'choose') { this.guard(new Event('submit')); return; }
        if (this.blocked) return;
        this.form.requestSubmit ? this.form.requestSubmit(this.atc) : this.atc.click();
      });
    }
  }
  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  /* ---------- recommendations ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const io = new IntersectionObserver(async ([en], obs) => {
        if (!en.isIntersecting) return; obs.disconnect();
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('product-recommendations');
          if (next && next.innerHTML.trim()) this.innerHTML = next.innerHTML;
        } catch (_) {}
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- rails ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-rail-btn]'); if (!b) return;
    const rail = document.getElementById(b.getAttribute('aria-controls')); if (!rail) return;
    rail.scrollBy({ left: +b.dataset.railBtn * rail.clientWidth * 0.75, behavior: reduce() ? 'auto' : 'smooth' });
  });

  /* ---------- filters & sorting ---------- */
  const facets = $('[data-facets]');
  if (facets) {
    facets.addEventListener('change', e => {
      const ctl = e.target.closest('[data-auto-submit], .price-range input'); if (!ctl) return;
      const inDrawer = ctl.closest('[data-filter-panel]');
      if (inDrawer && mobile.matches) return; // mobile: wait for "Show results"
      facets.requestSubmit ? facets.requestSubmit() : facets.submit();
    });
    facets.addEventListener('submit', () => {
      $$('input, select', facets).forEach(i => { if ((i.type === 'number' || i.type === 'hidden') && i.value === '' ) i.disabled = true; });
    });
  }

  /* ---------- footer: open columns on desktop, collapsible on mobile ---------- */
  const syncFooter = () => $$('.f-col').forEach(d => { d.open = !mobile.matches; });
  mobile.addEventListener('change', syncFooter); syncFooter();
  document.addEventListener('click', e => { const s = e.target.closest('.f-col > summary'); if (s && !mobile.matches) e.preventDefault(); });

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', () => { setHeaderH(); syncFooter(); });
})();
